<template>
    <div class="lnk-lov-check">
        <el-checkbox style="float: left" :indeterminate="isIndeterminate()" v-model="checkAll" @change="handleCheckAllChange" :disabled="disabled">全选</el-checkbox>
        <el-checkbox-group v-model="checkedValue" @change="handleCheckedValueChange">
            <el-checkbox v-for="(item,index) in options"
                         :key="index"
                         :label="item.val"
                         :disabled="disabled">
                {{item.name}}
            </el-checkbox>
        </el-checkbox-group>
        <div class="clearfix"></div>
    </div>
</template>

<script>


    export default {
        name: 'lnk-lov-check',
        data: function () {
            return {
                options: [],                                                    // 可选值
                checkAll: false,                                                // 是否全部选中
                checkedValue: this.$lv.$utils.deepCopy(this.modelVal) || []     // 选中的值
            };
        },
        props: {
            modelVal: Array,

            lov: String, // 值列表的类型
            excludeLov: Array, // 排除的值列表
            parentLovValue: String, // 父亲值列表
            parentLovType: String, // 父亲值列表类型
            disabled: Boolean // 是否禁用
        },
        model: {
            prop: 'modelVal',
            event: 'innerChange'
        },
        mounted: async function () {
            const defaultVal = await this.getstatus();
            if (!this.modelVal && !!defaultVal) {
                this.$emit('innerChange', defaultVal);
            }
        },
        watch: {
            modelVal(val) {
                this.checkedValue = this.$lv.$utils.deepCopy(val);
            },
            parentLovType: function () {
                this.checkedValue = [];
                this.getstatus();
            },
            parentLovValue: function () {
                this.checkedValue = [];
                this.getstatus();
            },
            lov: function () {
                this.checkedValue = [];
                this.getstatus();
            }
        },

        methods: {
            isIndeterminate() {
                const checkedCount = !!this.checkedValue ? this.checkedValue.length : 0;
                this.checkAll = checkedCount === this.options.length;
                return checkedCount > 0 && checkedCount < this.options.length;
            },
            handleCheckAllChange: function (val) {
                if (val) {
                    this.checkedValue = this.options.map(i => i.val)
                } else {
                    this.checkedValue = [];
                }
                this.$emit('innerChange', this.checkedValue);
            },
            handleCheckedValueChange: function () {
                this.$emit('innerChange', this.checkedValue);
            },
            getstatus: async function () {
                const {lovs, defaultVal} = await this.$lov.getLovData(this.lov, this.parentLovType, this.parentLovValue, this.excludeLov, true)
                this.options = lovs
                return defaultVal
            }
        }
    };
</script>

<style scoped lang="scss">
    .lnk-lov-check {
        .el-checkbox {
            margin: 0 24px 0 0;
        }

        .clearfix {
            content: '';
            display: table;
            clear: both;
        }
    }
</style>
